<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #ContactoClientes
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12)
        v-card(color='', style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 80px;border-radius:5px')
        v-card(color='', style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Contactos de Clientes (Email, WhatsApp y Persona de Contacto)

    // Modal para editar datos de contacto desde Admin
    v-dialog(v-model='dialogEditar', persistent max-width='650px')
      v-container(style='background-color:white !important;max-width: 650px;')
        v-card-title.justify-center
          span.headline Editar Contacto del Cliente
        div(style="margin-top: 15px;")
          v-flex(xs12)
            v-form
              v-text-field(
                outline
                disabled
                v-model="form.co_cli"
                prepend-inner-icon="perm_identity"
                label="Código / RIF:"
              )
              v-text-field(
                outline
                disabled
                v-model="form.cliente"
                prepend-inner-icon="business"
                label="Cliente:"
              )
              v-text-field(
                outline
                v-model="form.email"
                prepend-inner-icon="email"
                label="Correo Electrónico (Email):"
              )
              v-text-field(
                outline
                v-model="form.whatsapp"
                prepend-inner-icon="phone"
                label="WhatsApp:"
              )
              v-text-field(
                outline
                v-model="form.personaContacto"
                prepend-inner-icon="person"
                label="Persona de Contacto:"
              )
              div(style="display: flex; justify-content: center; margin-top: 10px;")
                v-btn(
                  style="background:#fe0100;border-radius:10px;color:white;"
                  :loading="guardando"
                  @click.native="guardarCambios"
                ) Guardar
                v-btn(
                  style="background:black;border-radius:10px;color:white;"
                  @click.native="cerrarModal"
                ) Cancelar

    // Barra de filtros y botón de exportar a Excel
    v-layout(row wrap align-center style="margin-top: 12px; padding: 0 8px;")
      v-flex(xs12 sm6 md5 style="padding: 4px;")
        v-text-field(
          v-model="search"
          append-icon="search"
          label="Buscar por cliente, RIF, vendedor, email, WhatsApp o contacto..."
          single-line
          hide-details
        )
      v-flex(xs12 sm6 md7 style="padding: 4px; display: flex; justify-content: flex-end; flex-wrap: wrap;")
        v-btn(
          style="background-color: #1D6F42; color: white; border-radius: 6px;"
          @click="exportarExcel"
        )
          v-icon(left dark) description
          | Exportar Excel ({{ registrosFiltrados.length }})
        v-btn(
          style="background-color: black; color: white; border-radius: 6px;"
          @click="initialize"
        )
          v-icon(left dark) refresh
          | Actualizar

    // Tabla de contactos de clientes
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color: black")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Contactos Actualizados ({{ contactos.length }})
        v-data-table.elevation-1(
          :headers='headers'
          :items="registrosFiltrados"
          :loading="cargando"
          :rows-per-page-items="[25, 50, 100, {text: 'Todos', value: -1}]"
          style="margin-top: 5px;"
        )
          template(slot='items', slot-scope='props')
            td {{ props.item.co_cli }}
            td {{ props.item.cliente || 'N/A' }}
            td {{ props.item.vendedor ? `${props.item.co_ven} - ${props.item.vendedor}` : (props.item.co_ven || 'N/A') }}
            td {{ props.item.email || 'Sin correo' }}
            td {{ props.item.whatsapp || 'Sin WhatsApp' }}
            td {{ props.item.personaContacto || 'Sin asignar' }}
            td {{ formatearFecha(props.item.fechaModificacion) }}
            td.justify-start.layout.px-0
              v-btn.mx-0(
                icon
                title="Editar Contacto"
                @click='abrirEditar(props.item)'
                style='margin-top: -9px;'
              )
                v-icon(color='teal') edit
              v-btn.mx-0(
                icon
                title="Eliminar Registro"
                @click='eliminarRegistro(props.item)'
                style='margin-top: -9px;'
              )
                v-icon(color='red') delete
</template>

<script>
import Api from "@/services/methods";
import moment from "moment";
import * as XLSX from "xlsx";

export default {
  name: "ContactoClientes",
  data: () => ({
    search: "",
    cargando: false,
    guardando: false,
    dialogEditar: false,
    contactos: [],
    form: {
      _id: "",
      co_cli: "",
      cliente: "",
      rif: "",
      co_ven: "",
      vendedor: "",
      email: "",
      whatsapp: "",
      personaContacto: ""
    },
    headers: [
      { text: "Código / RIF", value: "co_cli" },
      { text: "Cliente", value: "cliente" },
      { text: "Vendedor", value: "vendedor" },
      { text: "Email", value: "email" },
      { text: "WhatsApp", value: "whatsapp" },
      { text: "Persona de Contacto", value: "personaContacto" },
      { text: "Fecha Actualización", value: "fechaModificacion" },
      { text: "Acciones", sortable: false }
    ]
  }),
  computed: {
    registrosFiltrados() {
      if (!this.search || !this.search.trim()) {
        return this.contactos;
      }
      const q = this.search.toLowerCase().trim();
      return this.contactos.filter(item => {
        return (
          (item.co_cli && item.co_cli.toLowerCase().includes(q)) ||
          (item.cliente && item.cliente.toLowerCase().includes(q)) ||
          (item.co_ven && item.co_ven.toLowerCase().includes(q)) ||
          (item.vendedor && item.vendedor.toLowerCase().includes(q)) ||
          (item.email && item.email.toLowerCase().includes(q)) ||
          (item.whatsapp && item.whatsapp.toLowerCase().includes(q)) ||
          (item.personaContacto && item.personaContacto.toLowerCase().includes(q))
        );
      });
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.cargando = true;
      Api.get("clienteContacto")
        .then(res => {
          this.contactos = Array.isArray(res.data) ? res.data : [];
          this.cargando = false;
        })
        .catch(err => {
          console.error(err);
          this.cargando = false;
          this.$swal.fire(
            "Error",
            "No se pudieron cargar los datos de contacto de los clientes.",
            "error"
          );
        });
    },
    formatearFecha(fecha) {
      if (!fecha) return "N/A";
      return moment(fecha).format("DD/MM/YYYY HH:mm");
    },
    abrirEditar(item) {
      this.form = {
        _id: item._id,
        co_cli: item.co_cli || "",
        cliente: item.cliente || "",
        rif: item.rif || item.co_cli || "",
        co_ven: item.co_ven || "",
        vendedor: item.vendedor || "",
        email: item.email || "",
        whatsapp: item.whatsapp || "",
        personaContacto: item.personaContacto || ""
      };
      this.dialogEditar = true;
    },
    cerrarModal() {
      this.dialogEditar = false;
    },
    guardarCambios() {
      this.guardando = true;
      Api.post("clienteContacto", this.form)
        .then(() => {
          this.guardando = false;
          this.dialogEditar = false;
          this.$swal.fire(
            "Actualizado",
            "Los datos de contacto del cliente fueron actualizados.",
            "success"
          );
          this.initialize();
        })
        .catch(err => {
          console.error(err);
          this.guardando = false;
          this.$swal.fire(
            "Error",
            "No se pudieron guardar los cambios.",
            "error"
          );
        });
    },
    eliminarRegistro(item) {
      this.$swal
        .fire({
          title: "¿Eliminar registro?",
          text: `Se eliminará el registro de contacto de ${item.cliente || item.co_cli}`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar"
        })
        .then(result => {
          if (result.value) {
            Api.delete(`clienteContacto/${item._id}`)
              .then(() => {
                this.$swal.fire("Eliminado", "Registro eliminado correctamente.", "success");
                this.initialize();
              })
              .catch(err => {
                console.error(err);
                this.$swal.fire("Error", "No se pudo eliminar el registro.", "error");
              });
          }
        });
    },
    exportarExcel() {
      if (!this.registrosFiltrados.length) {
        this.$swal.fire("Atención", "No hay registros para exportar.", "warning");
        return;
      }

      try {
        const filas = this.registrosFiltrados.map(item => ({
          "Código Cliente": item.co_cli || "",
          "Cliente": item.cliente || "",
          "RIF": item.rif || item.co_cli || "",
          "Código Vendedor": item.co_ven || "",
          "Vendedor": item.vendedor || "",
          "Email": item.email || "",
          "WhatsApp": item.whatsapp || "",
          "Persona de Contacto": item.personaContacto || "",
          "Teléfono Profit": item.telefonos || "",
          "Fecha Actualización": this.formatearFecha(item.fechaModificacion)
        }));

        const ws = XLSX.utils.json_to_sheet(filas);
        ws["!cols"] = [
          { wch: 16 },
          { wch: 36 },
          { wch: 16 },
          { wch: 16 },
          { wch: 26 },
          { wch: 30 },
          { wch: 20 },
          { wch: 28 },
          { wch: 20 },
          { wch: 20 }
        ];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Contactos Clientes");
        const fechaArchivo = moment().format("YYYY-MM-DD");
        XLSX.writeFile(wb, `contactos_clientes_${fechaArchivo}.xlsx`);
      } catch (e) {
        console.error(e);
        this.$swal.fire("Error", "No se pudo exportar el archivo Excel.", "error");
      }
    }
  }
};
</script>

